import Icon from '@packages/shared/svg-sprites/ui/atoms/Icon';
import styles from './Banner.module.scss';

export const Banner = () => {
  return (
    <div className={styles.root}>
      <Icon name="clock" className={styles.bannerIcon} />

      <p className={styles.text}>
        Your first 3 minutes are <span className={styles.bold}>FREE!</span>
      </p>
    </div>
  );
};

export default Banner;
